'use client'

import { useCsrf } from '@/hooks/use-csrf'
import { Button } from '@/components/ui/button'

/**
 * Shown by every form when the token fetch has given up. Without it a
 * transient failure would leave the submit button disabled with no way back.
 */
export function CsrfRetry() {
  const { failed, retry } = useCsrf()
  if (!failed) return null
  return (
    <div
      role="alert"
      className="flex flex-col gap-3 rounded-sm border border-red-300 bg-red-50 px-4 py-3 text-[#1a1a1a] sm:flex-row sm:items-center sm:justify-between"
    >
      <p className="text-base">
        Couldn&apos;t get the form ready. Check your connection and try again.
      </p>
      <Button type="button" variant="ghost" size="sm" onClick={retry} className="shrink-0">
        Try again
      </Button>
    </div>
  )
}
